import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UG2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UG2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_774)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#FECA00"
        />
        <mask
          id="mask0_1813_774"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_774)">
          <rect width="24" height="3" fill="#272727" />
          <rect y="6" width="24" height="3" fill="#D74800" />
          <rect y="9" width="24" height="3" fill="#272727" />
          <rect y="15" width="24" height="3" fill="#D74800" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13.5C14.4853 13.5 16.5 11.4853 16.5 9C16.5 6.51472 14.4853 4.5 12 4.5C9.51472 4.5 7.5 6.51472 7.5 9C7.5 11.4853 9.51472 13.5 12 13.5Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2597 6.2466L9.46621 6.50696L10.2597 6.5749C10.2597 6.5749 10.388 6.88866 10.2597 7.1336C10.2271 7.19578 10.1431 7.27544 10.0359 7.37713C9.72074 7.676 9.20497 8.16512 9.20497 8.9598C9.20497 10.0248 11.2604 10.5078 11.2604 10.5078V11.0138C11.2604 11.0138 11.4989 11.1619 10.1378 11.1619C8.95745 11.1619 9.03127 11.61 9.07169 11.8553C9.07787 11.8929 9.08328 11.9257 9.08328 11.9514C9.08328 12.1451 9.65061 11.7577 9.91619 11.3721C10.056 11.1691 10.6414 11.1798 11.2422 11.2355C11.2897 11.2399 11.7278 12.1679 11.3474 12.6473C11.1877 12.8487 10.6359 12.8749 10.2912 12.8913C10.1154 12.8997 9.99346 12.9055 10.0048 12.9306C10.0133 12.9495 10.1172 12.9433 10.2683 12.9343C10.4569 12.923 10.719 12.9074 10.9605 12.9306C10.9971 12.9342 10.855 13.0575 10.7113 13.1823C10.5633 13.3107 10.4136 13.4407 10.4557 13.4426C10.5032 13.4449 10.7803 13.2913 11.0322 13.1518C11.2405 13.0364 11.4315 12.9306 11.4606 12.9306C11.6506 12.9306 11.8222 12.9541 11.9727 12.9746C12.2242 13.009 12.4169 13.0353 12.5381 12.9306C12.5755 12.8984 12.359 12.8465 12.1382 12.7936C11.9108 12.7391 11.6788 12.6836 11.7154 12.6473C11.9244 12.4398 11.8371 12.005 11.7683 11.6625C11.7375 11.5088 11.7103 11.3737 11.7154 11.2861C11.7333 10.9751 12.0623 11.1382 12.3209 11.2665C12.4342 11.3226 12.5339 11.3721 12.5881 11.3721C13.0779 11.3721 12.4698 10.7527 12.136 10.4127C12.1067 10.3829 12.0796 10.3552 12.0555 10.3303C11.8857 10.1551 12.0048 10.1786 12.2739 10.2318C12.4793 10.2725 12.772 10.3303 13.0905 10.3303C13.8262 10.3303 14.3632 10.0913 14.1766 9.44413C14.0536 9.01715 13.3797 8.87187 12.6757 8.72008C12.3127 8.64179 11.9415 8.56177 11.6338 8.44048C10.8767 8.14207 10.9153 7.70701 10.948 7.33913C10.9543 7.26758 10.9605 7.19857 10.9605 7.1336C10.9605 6.73459 11.6338 6.2466 11.6338 6.2466C11.6338 6.2466 11.3265 5.73169 10.8169 5.73169C10.3073 5.73169 10.2597 6.2466 10.2597 6.2466ZM11.6459 10.9325V10.5562C11.6459 10.5562 11.9605 10.5458 12.0709 10.8105C12.1813 11.0752 11.6459 10.9325 11.6459 10.9325Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.80762 5.03352L10.5678 5.93498L10.9615 5.84238L10.7727 4.93237L9.80762 5.03352Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7945 4.81557L10.8435 6.17086L11.4926 6.01114L11.7691 5.1235L10.7945 4.81557Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.183 7.07925C10.3263 7.07925 10.4426 6.96592 10.4426 6.82612C10.4426 6.68633 10.3263 6.573 10.183 6.573C10.0396 6.573 9.92334 6.68633 9.92334 6.82612C9.92334 6.96592 10.0396 7.07925 10.183 7.07925Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8325 5.06957L11.0768 5.97473L11.2363 6.34634L12.0997 6.00239L11.8325 5.06957Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5891 11.9199C13.5891 11.9199 14.9185 11.3261 14.9185 10.4956C14.9185 9.66512 12.76 8.7605 12.76 8.7605C12.76 8.7605 11.4903 9.05109 12.0626 9.43997C12.6349 9.82885 13.4016 9.97825 13.4016 10.4956C13.4016 11.0129 13.6117 11.5063 13.1858 11.5063C12.76 11.5063 13.5891 11.9199 13.5891 11.9199Z"
            fill="#D74800"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.671 8.60864C11.671 8.60864 11.2009 8.69123 11.2232 8.7676C11.2849 8.9787 11.9277 9.25366 12.2079 9.44404C12.7802 9.83292 13.3228 9.78924 13.7265 9.53616C14.1301 9.28308 11.671 8.60864 11.671 8.60864Z"
            fill="#FFFDFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_774">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UG2418Icon;
